"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import secondSectionTopVector from "@/assets/backgroundVectors/faqSecondSectionTopVector.png";
import faqSecondSectionBottomVector from "@/assets/backgroundVectors/faqSecondSectionBottomVector.png";
import feqSecondSectionRightVectors from "@/assets/backgroundVectors/feqSecondSectionRightVectors.png";
import { useTranslations } from "next-intl";
import CustomAccordion from "../common/CustomAccordion";
import PreviewScroll from "@/components/common/client/PreviewScroll.client";

function FaqsSectionTwo({ faqsFromStrapi }) {
  const t = useTranslations();

  const [searchText, setSearchText] = useState("");
  const [allQuestionsAndAnswers, setAllQuestionsAndAnswers] = useState(
    faqsFromStrapi.length > 0
      ? faqsFromStrapi
      : [
          {
            id: 1,
            question: t("faqs.section_2.question1"),
            answer: t("faqs.section_2.answer1")
          },
          {
            id: 2,
            question: t("faqs.section_2.question2"),
            answer: t("faqs.section_2.answer2")
          },
          {
            id: 3,
            question: t("foretagslan.section_6.question1"),
            answer: t("foretagslan.section_6.answer1")
          },
          {
            id: 4,
            question: t("foretagslan.section_6.question2"),
            answer: t("foretagslan.section_6.answer2")
          },
          {
            id: 5,
            question: t("foretagslan.section_6.question3"),
            answer: t("foretagslan.section_6.answer3")
          },
          {
            id: 6,
            question: t("foretagslan.section_6.question4"),
            answer: t("foretagslan.section_6.answer4")
          },
          {
            id: 7,
            question: t("foretagslan.section_6.question5"),
            answer: t("foretagslan.section_6.answer5")
          },
          {
            id: 8,
            question: t("foretagslan.section_6.question6"),
            answer: t("foretagslan.section_6.answer6")
          },
          {
            id: 9,
            question: t("foretagslan.section_6.question7"),
            answer: t("foretagslan.section_6.answer7")
          },
          {
            id: 10,
            question: t("foretagslan.section_6.question8"),
            answer: t("foretagslan.section_6.answer8")
          },
          {
            id: 11,
            question: t("foretagslan.section_6.question9"),
            answer: t("foretagslan.section_6.answer9")
          },
          {
            id: 12,
            question: t("fakturkop.section_6.question1"),
            answer: t("fakturkop.section_6.answer1")
          },
          {
            id: 13,
            question: t("fakturkop.section_6.question2"),
            answer: t("fakturkop.section_6.answer2")
          },
          {
            id: 14,
            question: t("fakturkop.section_6.question3"),
            answer: t("fakturkop.section_6.answer3")
          },
          {
            id: 15,
            question: t("fakturkop.section_6.question4"),
            answer: t("fakturkop.section_6.answer4")
          },
          {
            id: 16,
            question: t("fakturkop.section_6.question5"),
            answer: t("fakturkop.section_6.answer5")
          },
          {
            id: 17,
            question: t("fakturkop.section_6.question6"),
            answer: t("fakturkop.section_6.answer6")
          },
          {
            id: 18,
            question: t("fakturkop.section_6.question7"),
            answer: t("fakturkop.section_6.answer7")
          },
          {
            id: 19,
            question: t("fakturkop.section_6.question8"),
            answer: t("fakturkop.section_6.answer8")
          },
          {
            id: 20,
            question: t("fakturkop.section_6.question9"),
            answer: t("fakturkop.section_6.answer9")
          },
          {
            id: 21,
            question: t("inkasso.inkassoFaqs.question1"),
            answer: t("inkasso.inkassoFaqs.answer1")
          },
          {
            id: 22,
            question: t("inkasso.inkassoFaqs.question2"),
            answer: t("inkasso.inkassoFaqs.answer2")
          },
          {
            id: 23,
            question: t("inkasso.inkassoFaqs.question3"),
            answer: t("inkasso.inkassoFaqs.answer3")
          },
          {
            id: 24,
            question: t("inkasso.inkassoFaqs.question4"),
            answer: t("inkasso.inkassoFaqs.answer4")
          }
        ]
  );
  const [filteredResults, setFilteredResults] = useState(
    faqsFromStrapi.length > 0 ? faqsFromStrapi : allQuestionsAndAnswers
  );

  useEffect(() => {
    setAllQuestionsAndAnswers(faqsFromStrapi.length > 0 ? faqsFromStrapi : allQuestionsAndAnswers);
    setFilteredResults(faqsFromStrapi.length > 0 ? faqsFromStrapi : filteredResults);
  }, [faqsFromStrapi]);

  const handleChange = (e) => {
    setSearchText(e.target.value);
    let enteredText = e.target.value;
    if (!enteredText.trim()) {
      setFilteredResults(allQuestionsAndAnswers);
      return;
    }
    const results = allQuestionsAndAnswers.filter((item) =>
      item.question.toLowerCase().includes(enteredText.toLowerCase())
    );
    setFilteredResults(results);
  };

  const handleSearchClick = () => {
    if (!searchText.trim()) {
      setFilteredResults(allQuestionsAndAnswers);
      return;
    }
    const results = allQuestionsAndAnswers.filter((item) =>
      item.question.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredResults(results);
  };

  return (
    <>
      <div
        id="faqs-section"
        className="bg-[#FBF6F1] px-[clamp(16px,6vw,26px)] pt-15 pb-20 z-[1] relative md:p-8 flex flex-col gap-15 md:gap-[10vh] xl:pt-[10vh]  xl:px-[12%] xl:pb-50 text-[#5C2483] overflow-hidden"
      >
        <PreviewScroll targetId="faqs-section" />
        {/* All Background vectors */}
        {/* top left vector */}
        <div className="absolute hidden md:block top-0 left-0 -z-[1] xl:w-full">
          <Image
            src={secondSectionTopVector}
            alt="background vector"
            className="w-[30%] min-[1400px]:w-[26%]"
          />
        </div>
        <div className="absolute hidden md:block -bottom-[433px] left-0 -z-[1] xl:w-full">
          <Image
            src={faqSecondSectionBottomVector}
            alt="background vector"
            className="w-[30%] min-[1400px]:w-[61%]"
          />
        </div>
        <div
          className="absolute hidden md:block xl:w-[29.5%] top-0 right-0 -z-[1] xl:top-[10%] 
                  [@media(min-width:1400px)]:w-[28%] 
                  [@media(min-width:1400px)]:top-[30%]"
        >
          <Image src={feqSecondSectionRightVectors} alt="background vector" className="w-full" />
        </div>
        {/* Heading and Search Bar */}{" "}
        <div>
          <div className="w-full flex flex-col gap-10 px-7.5 md:px-14 py-5 md:py-11 bg-[#5C2483] rounded-[20px]">
            <p className="text-[clamp(16px,4.7vw,20px)] leading-[150%] md:text-[clamp(24px,2.083vw,40px)] md:leading-[clamp(15px,2.396vw,46px)] text-[#EDD2B9]">
              {t("faqs.section_2.card_title")}
            </p>
            <div className="flex flex-row items-center justify-between">
              <div className="w-[85%] md:w-[88%]">
                <input
                  className="
                  w-full px-3 py-[5px] md:py-6 md:px-10 bg-[#FBF6F1] text-[#7D509C] 
                  text-[16px]  md:text-[23px] font-normal 
                  border-none outline-none rounded-[45px] 
                placeholder-[#7D509C] placeholder-text-[32px] placeholder-font-normal placeholder-leading-[46px]"
                  placeholder={t("faqs.section_2.card_placeholder")}
                  value={searchText}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearchClick();
                    }
                  }}
                />
              </div>
              <div
                className="flex justify-center items-center cursor-pointer"
                onClick={handleSearchClick}
              >
                <Image
                  src="/Icons/GrayRightArrow.svg"
                  width={83}
                  height={83}
                  alt="purple arrow"
                  className="w-7.5 h-7.5 md:w-[83px] md:h-[83px]"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="">
          {filteredResults && filteredResults.length > 0 ? (
            <CustomAccordion
              items={filteredResults}
              textColor="#5C2483"
              borderColor="rgba(92, 36, 131, 0.8)"
              iconSrc="/Icons/purplebBottomArrow.svg"
              iconAlt="toggle arrow"
              iconSize={30}
              questionTextClass="text-[clamp(16px,4.5vw,20px)] leading-[clamp(21px,5.5vw,26px)] md:text-[clamp(24px,2.083vw,40px)] md:leading-[clamp(15px,2.396vw,46px)]"
              answerTextClass="body-copy-small-text"
              contentWidth="w-full md:w-[90%]"
            />
          ) : (
            <p className="text-center text-[#5C2483] text-[clamp(16px,4vw,18px)] mt-6">
              Tyvärr, inga resultat hittades.
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default FaqsSectionTwo;
